/* eslint-disable react/require-default-props */
import React, {
  createContext, useContext, useState,
} from 'react';

interface SessionReadyObject {
  setSessionReady: React.Dispatch<React.SetStateAction<boolean>>;
  sessionReady: boolean;
}


const SessionReadyContext = createContext<SessionReadyObject>({
  sessionReady: false,
  setSessionReady: () => undefined,
});
export const SessionReadyProvider = ({ children }: { children?: React.ReactNode | undefined }) => {
  const [sessionReady, setSessionReady] = useState(false);

  return (
    <SessionReadyContext.Provider value={{ sessionReady, setSessionReady }}>
      {children}
    </SessionReadyContext.Provider>
  );
};

export const useSessionReady = () => useContext(SessionReadyContext);
